// extracted by mini-css-extract-plugin
export var root = "Button-module--root--f0ded";
export var section = "Button-module--section--5f54c";